// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__2lGhW","home":"style_home__1R38q","profile":"style_profile__13x9K","halo":"style_halo__AhktD","thumbnail":"style_thumbnail__2ZLrN"};